import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import appStore from './state/store';

import QueryProvider from 'providers/query';
import AuthProvider from 'providers/auth/provider';

import AppRouter from './router';

import './global-styles/global.pcss';
import './global-styles/colors.pcss';
import './static';

const root = createRoot(document.getElementById('root'));
root.render(
  <Provider store={appStore}>
    <QueryProvider>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </QueryProvider>
  </Provider>
);